// import React from 'react';
// import {IconButton} from '@mui/material';

// import team from '../../assets/img/Microsoft_Teams-Logo.wine.svg';
// const containerStyle = {
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   height: '100vh', // 100% of the viewport height
// };

// const buttonStyle = {
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   justifyContent: 'center',
//   width: '200px', // Adjust the width as needed
//   height: '150px', // Adjust the height as needed
//   backgroundColor: '#ffffff', // Change the background color
//   color: 'black', // Change the text color
//   border: '2px solid #2980b9', // Change the border color
//   borderRadius: '8px',
//   cursor: 'pointer',
//   transition: 'background-color 0.3s',
// };

// const iconStyle = {
//   marginBottom: '8px',
// };

// const textStyles = {
//   fontSize: '12px',
//   textAlign: 'center',
// };

// const text = {
//   fontSize: '10px',
//   textAlign: 'center',
// };

// const boldTextStyle = {
//   fontWeight: 'bold',
// };

// const HelpAndSupportButton = () => {
//   const handleButtonClick = () => {
//     // Replace 'your-teams-channel-url' with the actual URL of your Teams channel
//     const teamsChannelUrl = 'https://teams.microsoft.com/l/team/19%3aKSrelpdhioSJ0nkJ3q4b8-8q7iw84Bo2ZkPeZ6g7uiA1%40thread.tacv2/conversations?groupId=251c1189-ed2e-4a9c-96fb-c03509bc384d&tenantId=e339bd4b-2e3b-4035-a452-2112d502f2ff';
//     const newWindow = window.open('', '_blank');
//     newWindow.opener = null;  // Set the opener to null for enhanced security
//     newWindow.location.href = teamsChannelUrl;
   
//   };
//   return (
//     <div style={containerStyle}>
   
//       <button
//         type="button"
//         style={buttonStyle}
//         onClick={handleButtonClick}
//         onKeyDown={(e) => {
//           if (e.key === 'Enter') {
//             handleButtonClick();
//           }
//         }}
//       >
//         <div style={iconStyle}>
//           <IconButton aria-label="Team">
//             <img src={team} alt="Teams" style={{ width: '60px', height: '60px' }} />
//           </IconButton>
//         </div>
//         <div style={textStyles}>
//           <span style={boldTextStyle}>Talk to our <br /> support engineer</span>
//         </div>
//         <div style={text}>
//           Let us know your difficulties with this application. We are happy to help.
//         </div>
//       </button>
//     </div>
//   );

// };

// export default HelpAndSupportButton;
import React, { useEffect, useState } from "react";
import axios from "axios";
import team from "../../assets/img/Microsoft_Teams-Logo.wine.svg";
import visibilityIcon from "../../assets/img/visibility.svg";
import fileIcon from "../../assets/img/fileIcon.svg";
import config from "../../config";

// Style constants removed in favor of Tailwind classes

const HelpAndSupportButton = () => {
  const [accessToken, setAccessToken] = useState(localStorage.getItem("accesstoken"));
  const [files, setFiles] = useState([]);

  // Keep access token in sync
  useEffect(() => {
    const handleAccessTokenChange = () => {
      const storedAccessToken = localStorage.getItem("accesstoken");
      if (storedAccessToken !== accessToken) {
        setAccessToken(storedAccessToken);
      }
    };
    window.addEventListener("storage", handleAccessTokenChange);
    const interval = setInterval(handleAccessTokenChange, 1000);
    return () => {
      window.removeEventListener("storage", handleAccessTokenChange);
      clearInterval(interval);
    };
  }, [accessToken]);

  // Fetch files dynamically
  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const response = await axios.get(`${config.API_URL}/getfilenames`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        if (Array.isArray(response.data)) {
          setFiles(response.data);
        } else {
          console.error("Unexpected response:", response.data);
        }
      } catch (error) {
        console.error("Error fetching filenames:", error);
      }
    };
    fetchFiles();
  }, [accessToken]);

  const handleDownload = async (fileName) => {
    try {
      const response = await axios.get(
        `${config.API_URL}/downloadfiles?fileName=${encodeURIComponent(fileName)}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
          responseType: "blob",
        }
      );
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      alert("Error downloading file. Please check file name or try again.");
    }
  };

  // Build cards array
  const cards = [
    {
      id: "support",
      icon: team,
      title: "Talk to our support engineer",
      description: "Let us know your difficulties with this application. We’re happy to help.",
      onClick: () =>
        window.open(
          "https://teams.microsoft.com/l/team/19%3aKSrelpdhioSJ0nkJ3q4b8-8q7iw84Bo2ZkPeZ6g7uiA1%40thread.tacv2/conversations?groupId=251c1189-ed2e-4a9c-96fb-c03509bc384d&tenantId=e339bd4b-2e3b-4035-a452-2112d502f2ff",
          "_blank"
        ),
    },
    ...files.map((file) => {
      const isVideo = file.fileName?.toLowerCase().endsWith(".mp4");
      const isPdf = file.fileName?.toLowerCase().endsWith(".pdf");
      return {
        id: file.id,
        icon: isVideo ? visibilityIcon : isPdf ? fileIcon : fileIcon,
        title: isVideo
          ? "Download Video Guide"
          : isPdf
          ? "Download Documentation"
          : `Download ${file.fileName}`,
        description: isVideo
          ? "Click to download the quick walkthrough video."
          : isPdf
          ? "Click to download the full user guide as PDF."
          : "Click to download this file.",
        onClick: () => handleDownload(file.fileName),
      };
    }),
  ];

  return (
    <div className="flex flex-wrap justify-center items-start gap-8 p-12 min-h-[calc(100vh-120px)] bg-slate-50">
      {cards.map((card) => (
        <div
          key={card.id}
          onClick={card.onClick}
          onKeyDown={(e) => e.key === "Enter" && card.onClick()}
          role="button"
          tabIndex={0}
          className="group flex flex-col items-center justify-between bg-white text-slate-800 border border-slate-100 rounded-2xl shadow-md hover:shadow-xl cursor-pointer p-6 w-[260px] h-[220px] transition-all duration-300 ease-out hover:-translate-y-2 hover:border-blue-500 hover:border-opacity-50"
        >
          <div className="flex flex-col items-center gap-3">
            <div className="p-3 bg-slate-50 rounded-2xl group-hover:bg-blue-50 transition-colors duration-300">
              <img src={card.icon} alt={card.title} className="w-12 h-12 object-contain" />
            </div>
            <div className="font-bold text-[15px] text-center text-slate-800 group-hover:text-blue-600 transition-colors duration-300 px-2 line-clamp-2">
              {card.title}
            </div>
          </div>
          <div className="text-xs text-center text-slate-500 leading-relaxed px-1 mt-auto">
            {card.description}
          </div>
        </div>
      ))}
    </div>
  );
};

export default HelpAndSupportButton;
